export default __webpack_public_path__ + "static/media/Perk_2.a66d6a88.png";